export enum RelationshipType {
    JointOwner = 14,
    PrimaryOwner = 15,
    Partner = 16
}
